import React from 'react';
import './footer.scss'
import repasseLogo from '../../../../images/repasseLogo.png'
import storeItunes from '../../../../images/storeItunes.png'
import storeGooglePlay from '../../../../images/storeGooglePlay.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faFacebookF, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import {Link} from "react-router-dom";
import { INSTAGRAM_URL } from '../../../../services/api';

class Footer extends React.Component {

    render() {

        return (
            <footer>
                <div className="row sepBar"> </div>
                <div className="container">

                    <div className="row">

                        <div className="col-12 col-sm-9 col-lg-5  storeLink">

                            <div className="repasseLogo">
                                <img src={repasseLogo} alt="Repasse Logo" />
                            </div>

                            <div className="row store">
                                <div className="col itunes">
                                    <a href="https://itunes.apple.com/us/app/repasse-motors/id1189648633?l=pt&ls=1&mt=8">
                                        <img src={storeItunes} alt="Itunes" />
                                    </a>
                                </div>

                                <div className="col gplay">
                                    <a href="https://itunes.apple.com/us/app/repasse-motors/id1189648633?l=pt&ls=1&mt=8">
                                        <img src={storeGooglePlay} alt="GPlay" />
                                    </a>
                                </div>
                            </div>

                            <div className={"footerInfo"}>
                                <p>Site desenvolvido e integrado à Plataforma REPASSE</p>
                            </div>

                        </div>

                        <div className="col-12 col-sm-3 col-lg-7 navegacao">
                            <div className="footerLinks">
                                <div>
                                    <p>Navegação</p>
                                </div>
                                <div>
                                    <a href={'/'} >Início</a>
                                </div>
                                <div>
                                    <a href={'/pesquisa'} >Pesquisa</a>
                                </div>
                                <div>
                                    <a href="/avaliacao">Venda Seu Carro Aqui</a>
                                </div>
                                <div>
                                    <Link to={'/contato'}>Dúvidas e Informações</Link>
                                </div>
                                <div>
                                    <Link to={'/sobre-nos'}>Quem Somos</Link>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>


                <div className="redesSociais">
                    <div className="col-md-12 socialLink">
                        <div className="instagran">
                            <a href={INSTAGRAM_URL} rel="noopener noreferrer" target="_blank">
                                <FontAwesomeIcon icon={faInstagram} size={"lg"} className={"socialIcon"}/>
                            </a>
                        </div>

                        <div className="facebook">
                            <a href="https://www.facebook.com/Danirepassefloripa/" rel="noopener noreferrer" target="_blank">
                                <FontAwesomeIcon icon={faFacebookF} size={"lg"} className={"socialIcon"}/>
                            </a>
                        </div>

                        <div className="whatsapp">
                            <a href={"https://api.whatsapp.com/send?phone=5548998267744"} target={"_blank"}>
                                <FontAwesomeIcon icon={faWhatsapp} size={"lg"} className={"socialIcon"}/>
                            </a>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;